export default __webpack_public_path__ + "static/cointelegraph-308-7089ede42f5da0b3eea83ff7f9fb515c.png";